export default class FetchJSON {
	
	static fetch(url, method = 'POST', data = {}) {
		return new Promise(function(resolve, reject) {
			let postData = JSON.stringify(data);
			let xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.withCredentials = true;
			xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
			xhr.send(postData);

			xhr.onload = function() {
				resolve(JSON.parse(xhr.response));
				destroy();
			}

			xhr.onerror = function(error) {
				reject(error);
				destroy();
			}

			function destroy() {
				xhr.onload = null;
				xhr.onerror = null;
				xhr = null;
			}
		});
	}
}